import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

@Component({
  selector: 'unity_libre',
  templateUrl: './unity_libre.component.html',
  styleUrls: ['./unity_libre.component.css']
})
export class UnityLibreComponent implements OnInit, OnDestroy {

  gameInstance: any;
  progress = 0;
  isReady = false;

  @Input() version: number = 3;
  build: any;
  cont_build: any;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {
    const loader = (window as any).UnityLoader;
    this.gameInstance = loader.instantiate('gameContainer_libre', `./assets/Build/BuildQuimica.json`, {
      onProgress: (gameInstance: any, progress: number) => {
        this.progress = progress;
        if (progress === 1) {
          this.isReady = true;
          this.setName();
        }
      }
    });
    this.build = document.getElementById("unity_libre");
    this.cont_build = document.getElementById("gameContainer_libre");
  }

  ngOnDestroy(): void {
    this.gameInstance.Quit();
  }

  setName() {
    this.gameInstance.SendMessage('JavascriptHook', 'SetNombre','Práctica en modo libre');
  }


  openFullscreen() {
    if (this.build.requestFullscreen) {
      this.build.style.width = "100px";
      this.cont_build.requestFullscreen();
    } else if (this.build.mozRequestFullScreen) {
      /* Firefox */
      this.build.mozRequestFullScreen();
    } else if (this.build.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.build.webkitRequestFullscreen();
    } else if (this.build.msRequestFullscreen) {
      /* IE/Edge */
      this.build.msRequestFullscreen();
    }
  }
}
